module.exports = __webpack_public_path__ + "img/history.3e57b029.jpg";